/** English — customer portal UI strings */
export const en = {
  'layout.portalTitle': 'Provider Portal',
  'layout.nav.dashboard': 'Dashboard',
  'layout.nav.bookingTemplates': 'Booking Templates',
  'layout.nav.contacts': 'Service',
  'layout.nav.enquiry': 'Inquiry',
  'layout.nav.bookings': 'Bookings',
  'layout.nav.bookingUsers': 'User Access Control',
  'layout.nav.slots': 'Slots',
  'layout.nav.batchJobs': 'Slot Generation',
  'layout.nav.promotions': 'Promotions',
  'layout.nav.customPush': 'Custom Push Notifications',
  'layout.nav.chat': 'Chat',
  'layout.nav.faq': 'FAQ',

  'pages.faq.title': 'Frequently Asked Questions',
  'pages.faq.subtitle': 'Find quick answers to common questions about services, bookings, slots, promotions, and account settings.',
  'pages.faq.searchPlaceholder': 'Search questions or keywords...',
  'pages.faq.categories.all': 'All Questions',
  'pages.faq.categories.account': 'Account & Setup',
  'pages.faq.categories.services': 'Services & Templates',
  'pages.faq.categories.bookings': 'Bookings & Slots',
  'pages.faq.categories.promotions': 'Promotions',
  'pages.faq.categories.support': 'Support & Security',
  'pages.faq.expandAll': 'Expand All',
  'pages.faq.collapseAll': 'Collapse All',
  'pages.faq.searchResultsCount': 'Found {{count}} matching question(s) for "{{query}}"',
  'pages.faq.noResultsTitle': 'No matching questions found',
  'pages.faq.noResultsSubtitle': 'Try adjusting your search query or select a different category.',
  'pages.faq.clearFilters': 'Clear Search & Filters',
  'pages.faq.needHelpTitle': 'Still have questions?',
  'pages.faq.needHelpSubtitle': 'Can\'t find the answer you\'re looking for? Reach out to our support team directly.',
  'pages.faq.chatWithUs': 'Chat with Support',
  'pages.faq.sendEnquiry': 'Send Inquiry',
  'pages.faq.helpCenter': 'Help Center',
  'pages.faq.items.q2.question': 'How do I reset or update my account password?',
  'pages.faq.items.q2.answer': 'Click on your profile initials/avatar in the top right header bar, select "Change Password", enter your current password followed by your new password, and click Save. You can also use the "Forgot Password" link on the login screen.',
  'pages.faq.items.q3.question': 'How do I create and publish a new Service Contact?',
  'pages.faq.items.q3.answer': 'Go to the Service page from the sidebar menu, click "+ Add Service", fill out all required details including category, city, address, pricing structure, description, and images, then submit to save.',
  'pages.faq.items.q4.question': 'What are Booking Templates and how do I configure them?',
  'pages.faq.items.q4.answer': 'Booking Templates define custom form fields and questions that customers must fill when booking your service. Go to "Booking Templates", select a service, and add input fields such as text, dropdowns, dates, or file upload requirements.',
  'pages.faq.items.q5.question': 'How do customer bookings work and how do I manage them?',
  'pages.faq.items.q5.answer': 'When customers place a booking for your service, it appears on the "Bookings" screen. You can review booking details, customer information, status (Pending, Confirmed, Cancelled), and update booking states as services progress.',
  'pages.faq.items.q6.question': 'How do I generate time slots for my services?',
  'pages.faq.items.q6.answer': 'You can generate time slots individually in the "Slots" screen or use automated batch generation in "Slot Generation" (Batch Jobs) to schedule multiple recurring date and time slots across weeks or months.',
  'pages.faq.items.q7.question': 'How do promotional discount codes work?',
  'pages.faq.items.q7.answer': 'In the "Promotions" tab, you can create promo codes with percentage or fixed amount discounts, set validity start and end dates, maximum usage limits, and assign them to specific services.',
  'pages.faq.items.q8.question': 'Can I deactivate or delete a promotion?',
  'pages.faq.items.q8.answer': 'Yes, you can toggle the active status of any promo code instantly or delete it permanently from the Promotions management table.',
  'pages.faq.items.q9.question': 'How do I chat with users or customers?',
  'pages.faq.items.q9.answer': 'Open the "Chat" screen from the sidebar menu. You will see active user conversations linked to your services. Select a conversation to send and receive real-time messages, media, and booking updates.',
  'pages.faq.items.q10.question': 'Is my provider account data safe and encrypted?',
  'pages.faq.items.q10.answer': 'Yes, all sensitive data exchanges between the customer portal and our backend are encrypted using AES/RSA cryptographic layers, TLS protocols, and secure token authentication.',
  'pages.faq.items.q11.question': 'What are the image upload requirements and validations for Service Contacts and Promotions?',
  'pages.faq.items.q11.answer': 'When uploading images for Service Contacts (BannerImages, LogoPicture) or Promotions:\n\n• Supported File Formats: PNG, JPG, JPEG, WEBP\n• Maximum File Size: Up to 10MB per image file\n• Required Dimensions:\n  - Image Size: 355 × 355 px (1:1 square ratio).\n• Validations: Any non-image file type or file exceeding 10MB will be rejected automatically with a warning alert.',

  'layout.nav.chatUnread': '{{count}} unread messages',
  'pages.chat.title': 'Messages',
  'pages.chat.subtitle': 'Chat with users regarding services',
  'pages.chat.search': 'Search users...',
  'pages.chat.typeMessage': 'Type a message...',
  'pages.chat.noSelect': 'Select a conversation to start chatting',
  'pages.chat.typing': 'typing...',
  'pages.chat.selectContact': 'Select Service',
  'pages.chat.noConversations': 'No users found',
  'pages.chat.allServices': 'All Services',
  'layout.notifications.title': 'Notifications',
  'layout.notifications.markAllRead': 'Mark all as read',
  'layout.notifications.history': 'Notification history',
  'layout.notifications.viewAll': 'View all',
  'layout.notifications.allTitle': 'All notifications',
  'layout.notifications.filterLabel': 'Category',
  'layout.notifications.filterAll': 'All categories',
  'layout.notifications.filterAllNotifications': 'All notifications',
  'layout.notifications.pageSubtitle': 'View and manage your recent notifications.',
  'layout.notifications.loading': 'Loading notifications…',
  'layout.notifications.table.type': 'Type',
  'layout.notifications.table.title': 'Title',
  'layout.notifications.table.message': 'Message',
  'layout.notifications.table.received': 'Received',
  'layout.notifications.table.status': 'Status',
  'layout.notifications.table.actions': 'Actions',
  'layout.notifications.statusRead': 'Read',
  'layout.notifications.statusUnread': 'Unread',
  'layout.notifications.markRead': 'Mark as read',
  'layout.notifications.openLink': 'Open link',
  'layout.notifications.filterPromotion': 'Promotion',
  'layout.notifications.filterEvents': 'Events',
  'layout.notifications.filterContact': 'Contact',
  'layout.notifications.filterUser': 'User',
  'layout.notifications.filterSupport': 'Customer support',
  'layout.notifications.filterBooking': 'Booking',
  'layout.notifications.filterEnquiry': 'Inquiry',
  'layout.notifications.empty': 'No notifications yet',
  'layout.notifications.loadError': 'Could not load notifications',
  'layout.notifications.close': 'Close',
  'layout.notifications.back': 'Back to previous page',
  'layout.page.back': 'Back',
  'layout.notifications.marking': 'Updating…',
  'layout.profile.tooltip': 'My profile',
  'layout.profile.title': 'Profile',
  'layout.profile.name': 'Name',
  'layout.profile.email': 'Email',
  'layout.profile.role': 'Role',
  'layout.profile.loading': 'Loading…',
  'layout.profile.changeName': 'Change name',
  'layout.profile.changePassword': 'Change password',
  'layout.profile.language': 'Language',
  'layout.profile.languageEn': 'English',
  'layout.profile.languageDe': 'German',
  'layout.profile.logout': 'Logout',
  'layout.dialog.changeNameTitle': 'Change display name',
  'layout.dialog.changeNameSubtitle': 'This is how your name appears in the portal.',
  'layout.dialog.changePasswordTitle': 'Change password',
  'layout.dialog.changePasswordSubtitle': 'Enter your current password, then your new password twice.',
  'layout.dialog.passwordNewSection': 'New password',
  'layout.dialog.displayName': 'Display name',
  'layout.dialog.firstName': 'First name',
  'layout.dialog.lastName': 'Last name',
  'layout.dialog.businessName': 'Business name',
  'layout.dialog.currentPassword': 'Current password',
  'layout.dialog.newPassword': 'New password',
  'layout.dialog.confirmPassword': 'Confirm new password',
  'layout.dialog.cancel': 'Cancel',
  'layout.dialog.save': 'Save',
  'layout.dialog.updatePassword': 'Update password',
  'layout.toast.nameUpdated': 'Name updated successfully.',
  'layout.toast.passwordUpdated': 'Password updated successfully.',
  'layout.toast.error': 'Something went wrong. Please try again.',
  'layout.toast.passwordMismatch': 'New password and confirmation do not match.',
  'layout.nav.helpCenter': 'Help Center',
  'layout.dialog.helpCenterTitle': 'Help Center',
  'layout.dialog.helpCenterSubtitle': 'Need help? Send us a message and we will get back to you.',
  'layout.dialog.helpCenterMessage': 'Message',
  'layout.toast.helpCenterSuccess': 'Your message has been sent successfully.',


  'pages.templates.title': 'Booking Templates',

  'pages.dashboard.title': 'Dashboard',
  'pages.dashboard.subtitle': 'Your customer portal overview and analytics',
  'pages.dashboard.card.totalBooking': 'Total Booking',
  'pages.dashboard.card.todayBooking': 'Today Booking',
  'pages.dashboard.card.completedBookings': 'Completed',
  'pages.dashboard.card.todaySlots': 'Today slots',
  'pages.dashboard.card.change1': '+12% since last month',
  'pages.dashboard.card.change2': '+8% since yesterday',
  'pages.dashboard.card.change3': '+15% avg daily',
  'pages.dashboard.legend.bookings': 'Bookings',
  'pages.dashboard.legend.slots': 'Slots',
  'pages.dashboard.chart.bookingsVsSlots': 'Bookings vs Slots',
  'pages.dashboard.chart.overallInfo': 'Overall Information',
  'pages.dashboard.chart.customersOverview': 'Customers Overview',
  'pages.dashboard.period': 'Period',
  'pages.dashboard.period.thisWeek': 'This Week',
  'pages.dashboard.period.thisMonth': 'This Month',
  'pages.dashboard.period.thisYear': 'This Year',
  'pages.dashboard.period.last3Months': 'Last 3 Months',
  'pages.dashboard.period.last6Months': 'Last 6 Months',
  'pages.dashboard.period.lastYear': 'Last Year',
  'pages.dashboard.pie.firstTime': 'First Time',
  'pages.dashboard.pie.return': 'Return',
  'pages.dashboard.pie.new': 'New',
  'pages.dashboard.summary.completed': 'Completed Bookings',
  'pages.dashboard.summary.cancelled': 'Cancelled Bookings',
  'pages.dashboard.summary.totalSlots': 'Total Slots',
  'pages.dashboard.today.title': "Today's Booking",
  'pages.dashboard.today.colTime': 'Time',
  'pages.dashboard.today.colMeetingType': 'Meeting Type',
  'pages.dashboard.today.colTitle': 'Title',
  'pages.dashboard.today.colContact': 'Contact Name',
  'pages.dashboard.today.colUserName': 'User Name',
  'pages.dashboard.today.colEmail': 'Email',
  'pages.dashboard.today.colStatus': 'Status',
  'pages.dashboard.today.colActions': 'Actions',
  'pages.dashboard.today.empty': 'No bookings for today',

  'pages.dashboard.views.title': 'User Views & Engagement',
  'pages.dashboard.views.subtitle': 'Track views across your services and promotions over time',
  'pages.dashboard.views.module': 'Module',
  'pages.dashboard.views.contact': 'Contacts / Services',
  'pages.dashboard.views.promotion': 'Promotions',
  'pages.dashboard.views.timeFilter': 'Timeframe',
  'pages.dashboard.views.currentWeek': 'Current Week',
  'pages.dashboard.views.byMonth': 'By Month',
  'pages.dashboard.views.fullYear': 'Full Year',
  'pages.dashboard.views.year': 'Year',
  'pages.dashboard.views.month': 'Month',
  'pages.dashboard.views.totalViews': 'Total Views',
  'pages.dashboard.views.contactViews': 'Contact Views',
  'pages.dashboard.views.promotionViews': 'Promotion Views',
  'pages.dashboard.views.dailyAverage': 'Daily Average',
  'pages.dashboard.views.peakViews': 'Peak Day Views',
  'pages.dashboard.views.topItems': 'Top Performing Items',
  'pages.dashboard.views.noTopItems': 'No viewed items recorded for this timeframe',
  'pages.dashboard.views.noData': 'No view data available for this timeframe',
  'pages.dashboard.views.viewsCount': '{{count}} views',
  'pages.dashboard.views.chartArea': 'Area',
  'pages.dashboard.views.chartBar': 'Bar',

  'pages.bookings.title': 'User Booking Management',
  'pages.bookings.appointments': 'Appointments',
  'pages.bookings.subtitle': 'Track and manage all bookings created from your slots',
  'pages.bookings.providerUnavailable': 'Provider Unavailable',
  'pages.bookings.transfer': 'Transfer Bookings',
  'pages.bookings.refresh': 'Refresh',
  'pages.bookings.add': 'Add Booking',
  'pages.bookings.filter.status': 'Status',
  'pages.bookings.filter.all': 'All',
  'pages.bookings.filter.search': 'Search by title, customer or code',
  'pages.bookings.filter.searchTitleCustomer': 'Search by title, customer & code',
  'pages.bookings.filter.searchTitleCustomerPlaceholder': 'Title, customer name or confirmation code',
  'pages.bookings.searchPlaceholder': 'Search by title, customer or code...',
  'pages.bookings.filter.bookingStatus': 'Approval Status',
  'pages.bookings.filter.allStatuses': 'All Statuses',
  'pages.bookings.filter.contact': 'Service',
  'pages.bookings.filter.contactTitle': 'Service title',
  'pages.bookings.filter.template': 'Template',
  'pages.bookings.filter.startDate': 'Start Date',
  'pages.bookings.filter.endDate': 'End Date',
  'pages.bookings.filter.slotDate': 'Slot date',
  'pages.bookings.filter.slotDateTitle': 'Select Date',
  'pages.bookings.clearSlotDate': 'Clear slot date',
  'pages.bookings.meetingType.online': 'Online',
  'pages.bookings.meetingType.offline': 'Offline',
  'pages.bookings.filter.allContacts': 'All services',
  'pages.bookings.filter.allTemplates': 'All templates',
  'pages.bookings.clearFilters': 'Clear',
  'pages.bookings.dateUnknown': 'Date not set',
  'pages.bookings.table.time': 'Time',
  'pages.bookings.table.bookingDate': 'Booking Date',
  'pages.bookings.table.slotDate': 'Slot date',
  'pages.bookings.table.title': 'Title',
  'pages.bookings.table.customerName': 'Customer Name',
  'pages.bookings.table.userName': 'User Name',
  'pages.bookings.table.meetingType': 'Meeting Type',
  'pages.bookings.table.joinOnlineMeeting': 'Join online Meeting',
  'pages.bookings.table.customerNumber': 'Customer Number',
  'pages.bookings.table.contact': 'Service',
  'pages.bookings.table.template': 'Template',
  'pages.bookings.table.duration': 'Duration',
  'pages.bookings.table.location': 'Location',
  'pages.bookings.table.price': 'Price',
  'pages.bookings.table.type': 'Type',
  'pages.bookings.table.notes': 'Notes',
  'pages.bookings.table.status': 'Status',
  'pages.bookings.table.actions': 'Actions',
  'pages.bookings.pagination.rowsPerPage': 'Rows per page',
  'pages.bookings.pagination.displayedRows': '{{from}}–{{to}} of {{count}}',
  'pages.bookings.pagination.unknownTotal': '{{from}}–{{to}} of many',
  'pages.bookings.loading': 'Loading bookings…',
  'pages.bookings.empty': 'No bookings found',
  'pages.bookings.emptyHint': 'Try adjusting your filters or create a new booking.',
  'pages.bookings.stats.total': 'Total Bookings',
  'pages.bookings.stats.pending': 'Pending',
  'pages.bookings.stats.confirmed': 'Confirmed',
  'pages.bookings.stats.completed': 'Completed',
  'pages.bookings.stats.cancelled': 'Cancelled',
  'pages.bookings.dialog.cancelTitle': 'Cancel Booking - Provider Unavailable',
  'pages.bookings.dialog.cancelSubtitle': 'Cancel a specific booking by providing a reason (e.g., provider unavailable).',
  'pages.bookings.dialog.selectBooking': 'Select Booking',
  'pages.bookings.dialog.noActionableBookings': 'No pending or confirmed bookings are available to select.',
  'pages.bookings.dialog.cancelReason': 'Cancellation Reason',
  'pages.bookings.dialog.cancelReasonPlaceholder': 'e.g., Provider is sick, emergency, etc.',
  'pages.bookings.dialog.cancelButton': 'Cancel Booking',
  'pages.bookings.dialog.cancelErrorBooking': 'Select a booking.',
  'pages.bookings.dialog.cancelErrorReason': 'Enter a cancellation reason.',
  'pages.bookings.dialog.updateStatusTitle': 'Update Status',
  'pages.bookings.dialog.statusLabel': 'Status',
  'pages.bookings.dialog.notesLabel': 'Notes',
  'pages.bookings.dialog.notifyCustomer': 'Notify Customer',
  'pages.bookings.dialog.updateStatusButton': 'Update Status',
  'pages.bookings.dialog.transferTitle': 'Transfer Booking',
  'pages.bookings.dialog.transferSubtitle': 'Transfer a booking to another provider and slot.',
  'pages.bookings.dialog.selectBookingFull': 'Select Booking (Customer Name - Title)',
  'pages.bookings.dialog.toProvider': 'To Provider',
  'pages.bookings.dialog.toSlot': 'To Slot',
  'pages.bookings.dialog.transferReason': 'Transfer Reason',
  'pages.bookings.dialog.transferReasonPlaceholder': 'e.g., Schedule change, emergency coverage',
  'pages.bookings.dialog.transferButton': 'Transfer Booking',
  'pages.bookings.dialog.transferErrorBooking': 'Select a booking.',
  'pages.bookings.dialog.transferErrorProvider': 'Select a provider.',
  'pages.bookings.dialog.transferErrorSlot': 'Select a slot.',
  'pages.bookings.dialog.transferErrorReason': 'Enter a transfer reason.',
  'pages.bookings.dialog.schedule': 'Schedule',
  'pages.bookings.dialog.confirmationCode': 'Confirmation code',
  'pages.bookings.dialog.created': 'Booking created',
  'pages.bookings.dialog.appointmentDate': 'Appointment date',
  'pages.bookings.dialog.startTime': 'Start time',
  'pages.bookings.dialog.endTime': 'End time',
  'pages.bookings.dialog.noDetails': 'No booking details available.',
  'pages.bookings.dialog.sendReminder': 'Send Reminder',
  'pages.bookings.dialog.sendReminderTo': 'Send Reminder to {{title}}',
  'pages.bookings.dialog.reminderType': 'Reminder Type',
  'pages.bookings.dialog.customMessage': 'Custom Message (Optional)',
  'pages.bookings.dialog.customMessagePlaceholder': 'Enter a custom message to include in the reminder...',
  'pages.bookings.dialog.remindCustomerSubtitle': 'Send a manual notification via email or SMS to user.',
  'pages.bookings.dialog.noSlots': 'No slots',
  'pages.bookings.toast.created': 'Booking created successfully',
  'pages.bookings.toast.updated': 'Booking updated successfully',
  'pages.userBookingBlocks.title': 'User Access Control',
  'pages.userBookingBlocks.subtitle': 'Control user account access by blocking or unblocking users and reviewing booking details.',
  'pages.userBookingBlocks.refresh': 'Refresh',
  'pages.userBookingBlocks.table.displayName': 'Display name',
  'pages.userBookingBlocks.table.email': 'Email',
  'pages.userBookingBlocks.table.totalBookings': 'Total Booking',
  'pages.userBookingBlocks.table.bookingStatus': 'Users Blocked',
  'pages.userBookingBlocks.table.reason': 'Reason',
  'pages.userBookingBlocks.table.actions': 'Actions',
  'pages.userBookingBlocks.viewDetails': 'View details',
  'pages.userBookingBlocks.on': 'On',
  'pages.userBookingBlocks.off': 'Off',
  'pages.userBookingBlocks.loading': 'Loading users…',
  'pages.userBookingBlocks.empty': 'No users found',
  'pages.userBookingBlocks.detailsTitle': 'User booking details',
  'pages.userBookingBlocks.bookingsListTitle': 'Bookings',
  'pages.userBookingBlocks.noBookings': 'No bookings found for this user',
  'pages.userBookingBlocks.details.bookingTitle': 'Title',
  'pages.userBookingBlocks.details.bookingStatus': 'Status',
  'pages.userBookingBlocks.details.bookingDate': 'Slot date',
  'pages.userBookingBlocks.details.slotTime': 'Slot time',
  'pages.userBookingBlocks.details.contactTitle': 'Contact title',
  'pages.userBookingBlocks.details.customerName': 'Customer',
  'pages.userBookingBlocks.details.customerEmail': 'Customer email',
  'pages.userBookingBlocks.details.customerPhone': 'Customer phone',
  'pages.userBookingBlocks.details.serviceAddress': 'Service address',
  'pages.userBookingBlocks.details.bookingsCount': '{{total}} bookings',
  'pages.userBookingBlocks.blockDialog.title': 'Block user from booking',
  'pages.userBookingBlocks.blockDialog.subtitle': 'Future bookings with you will be cancelled. Please give a short reason.',
  'pages.userBookingBlocks.blockDialog.reason': 'Reason',
  'pages.userBookingBlocks.blockDialog.reasonPlaceholder': 'e.g. repeated no-shows',
  'pages.userBookingBlocks.blockDialog.confirm': 'Block user',
  'pages.userBookingBlocks.blockDialog.reasonRequired': 'Reason is required',
  'pages.userBookingBlocks.toast.loadError': 'Failed to load users',
  'pages.userBookingBlocks.toast.toggleError': 'Failed to update booking access',
  'pages.userBookingBlocks.toast.detailsError': 'Failed to load user details',
  'pages.userBookingBlocks.toast.blocked': 'Booking access turned off',
  'pages.userBookingBlocks.toast.unblocked': 'Booking access turned on',
  'pages.userBookingBlocks.reportUser': 'Report user',
  'pages.userBookingBlocks.reportDialog.title': 'Report User',
  'pages.userBookingBlocks.reportDialog.subtitle': 'Select a reason and write a detailed description to submit a report against this user.',
  'pages.userBookingBlocks.reportDialog.reasonLabel': 'Reason for reporting',
  'pages.userBookingBlocks.reportDialog.selectReasonPlaceholder': 'Select a reason...',
  'pages.userBookingBlocks.reportDialog.descriptionLabel': 'Description',
  'pages.userBookingBlocks.reportDialog.descriptionPlaceholder': 'Write detailed description for reporting...',
  'pages.userBookingBlocks.reportDialog.confirm': 'Submit Report',
  'pages.userBookingBlocks.reportDialog.reasonRequired': 'Please select a reason for reporting',
  'pages.userBookingBlocks.toast.reported': 'User report submitted successfully',
  'pages.userBookingBlocks.toast.reportError': 'Failed to submit user report',
  'pages.userBookingBlocks.reportReason.noShow': 'No Show / Did Not Arrive',
  'pages.userBookingBlocks.reportReason.abusive': 'Abusive or Offensive Behavior',
  'pages.userBookingBlocks.reportReason.harassment': 'Harassment or Misconduct',
  'pages.userBookingBlocks.reportReason.spam': 'Spam or Fake Booking',
  'pages.userBookingBlocks.reportReason.misuse': 'Misuse of Service',
  'pages.userBookingBlocks.reportReason.fraud': 'Fraudulent Activity',
  'pages.userBookingBlocks.reportReason.other': 'Other Reason',

  'pages.slots.title': 'Slots Management',
  'pages.slots.subtitle': 'Plan and coordinate your business availability and bookings',
  'pages.slots.refresh': 'Refresh',
  'pages.contacts.title': 'Service Management',
  'pages.contacts.subtitle': 'Manage and organize your services and provider listings',
  'pages.contacts.quickLinks': 'Quick links',
  'pages.contacts.quickLinksPlaceholder': 'Choose an action',
  'pages.contacts.goToNotifications': 'All notifications',
  'pages.bookingTemplates.pageTitle': 'Booking Templates',
  'pages.bookingTemplates.subtitle': 'Configure and manage your service booking experience',
  'pages.batchJobs.title': 'Slot Generation',
  'pages.batchJobs.subtitle': 'Configure automatic slot generation and manage scheduled jobs',
  'pages.batchJobs.refresh': 'Refresh',
  'pages.batchJobs.configureAutoSlots': 'Configure Auto Slots',
  'pages.batchJobs.stats.totalJobs': 'Total Jobs',
  'pages.batchJobs.stats.enabled': 'Enabled',
  'pages.batchJobs.stats.running': 'Running',
  'pages.batchJobs.stats.slotsGenerated': 'Slots Generated',
  'pages.batchJobs.loading': 'Loading batch jobs…',
  'pages.batchJobs.empty.title': 'No batch jobs yet',
  'pages.batchJobs.empty.hint': 'Use "Configure Auto Slots" to create an automatic slot generation job for a contact.',
  'pages.batchJobs.table.name': 'Name',
  'pages.batchJobs.table.slotGeneration': 'Slot generation',
  'pages.batchJobs.table.schedule': 'Schedule',
  'pages.batchJobs.table.status': 'Status',
  'pages.batchJobs.table.enabled': 'Enabled',
  'pages.batchJobs.table.lastRun': 'Last Run',
  'pages.batchJobs.table.nextRun': 'Next Run',
  'pages.batchJobs.table.slotsGenerated': 'Slots Generated',
  'pages.batchJobs.table.actions': 'Actions',
  'pages.batchJobs.tooltip.run': 'Run now',
  'pages.batchJobs.tooltip.edit': 'Edit configuration',
  'pages.batchJobs.dialog.editTitle': 'Edit Auto Slot Configuration',
  'pages.batchJobs.dialog.createTitle': 'Configure Auto Slot Generation',
  'pages.batchJobs.form.contact': 'Contact',
  'pages.batchJobs.form.selectContact': 'Select contact',
  'pages.batchJobs.form.autoGenEnabled': 'Auto generation enabled',
  'pages.batchJobs.form.scheduleCron': 'Schedule (cron)',
  'pages.batchJobs.form.scheduleHelp': 'e.g. 0 2 * * * = daily at 2:00 AM',
  'pages.batchJobs.form.daysInAdvance': 'Days in advance',
  'pages.batchJobs.form.defaultTemplate': 'Default template',
  'pages.batchJobs.form.selectTemplate': 'Select template',
  'pages.batchJobs.form.autoConfirm': 'Auto confirm generated slots',
  'pages.batchJobs.form.notifyOnGen': 'Notify on generation',
  'pages.batchJobs.form.notificationEmail': 'Notification email',
  'pages.batchJobs.form.emailPlaceholder': 'provider@example.com',
  'pages.batchJobs.err.contactRequired': 'Contact is required',
  'pages.batchJobs.err.scheduleRequired': 'Schedule is required when auto-generation is enabled',
  'pages.batchJobs.err.daysRange': 'Days in advance must be between 1 and 365',
  'pages.batchJobs.err.templateRequired': 'Default template is required',
  'pages.batchJobs.err.emailRequired': 'Notification email is required',
  'pages.batchJobs.err.emailInvalid': 'Enter a valid email address',
  'pages.batchJobs.toast.loadFailed': 'Failed to load batch jobs',
  'pages.batchJobs.toast.saveOk': 'Configuration saved successfully',
  'pages.batchJobs.toast.saveFail': 'Failed to save',
  'pages.batchJobs.toast.saveErr': 'Failed to save configuration',
  'pages.batchJobs.toast.runOk': 'Job run triggered successfully',
  'pages.batchJobs.toast.runFail': 'Run failed',
  'pages.batchJobs.toast.runErr': 'Failed to run job',
  'pages.batchJobs.cron.daily2am': 'Daily at 2:00 AM',
  'pages.batchJobs.cron.dailyMidnight': 'Daily at midnight',
  'pages.batchJobs.cron.every6h': 'Every 6 hours',
  'pages.batchJobs.cron.weeklySun': 'Weekly (Sunday 3:00 AM)',
  'pages.batchJobs.cron.weekdays': 'Weekdays at 2:00 AM',
  'pages.enquiry.title': 'Inquiry',
  'pages.enquiry.subtitle': 'Review customer inquiries and manage incoming messages',
  'pages.enquiry.filter.contact': 'Contact',
  'pages.enquiry.filter.allContacts': 'All Contacts',
  'pages.enquiry.filter.status': 'Status',
  'pages.enquiry.filter.allStatuses': 'All Statuses',
  'pages.enquiry.filter.label': 'Filter',
  'pages.enquiry.filter.all': 'All',
  'pages.enquiry.filter.new': 'New',
  'pages.enquiry.filter.replied': 'Replied',
  'pages.enquiry.filter.search': 'Search inquiries...',
  'pages.enquiry.table.userName': 'User Name',
  'pages.enquiry.table.email': 'Email',
  'pages.enquiry.table.phone': 'Phone',
  'pages.enquiry.table.contact': 'Contact',
  'pages.enquiry.table.date': 'Date',
  'pages.enquiry.table.status': 'Status',
  'pages.enquiry.table.message': 'Message',
  'pages.enquiry.table.actions': 'Actions',
  'pages.enquiry.status.pending': 'Pending',
  'pages.enquiry.status.inProgress': 'In Progress',
  'pages.enquiry.status.completed': 'Completed',
  'pages.enquiry.status.cancelled': 'Cancelled',
  'pages.enquiry.statusUpdateSuccess': 'Inquiry status updated successfully',
  'pages.enquiry.statusUpdateError': 'Failed to update inquiry status',
  'pages.enquiry.details.title': 'Inquiry Details',
  'pages.enquiry.details.sender': 'Sender',
  'pages.enquiry.details.contact': 'Contact',
  'pages.enquiry.details.email': 'Email',
  'pages.enquiry.details.phone': 'Phone Number',
  'pages.enquiry.details.date': 'Created Date',
  'pages.enquiry.details.status': 'Status',
  'pages.enquiry.details.shortDesc': 'Short Description',
  'pages.enquiry.details.message': 'Message',
  'pages.enquiry.details.updatedAt': 'Last Updated',
  'pages.enquiry.deleteDialog.title': 'Delete Inquiry',
  'pages.enquiry.deleteDialog.confirm': 'Are you sure you want to delete this inquiry? This action cannot be undone.',
  'pages.enquiry.loading': 'Loading inquiries...',
  'pages.enquiry.loadError': 'Failed to load inquiries',
  'pages.enquiry.deleteSuccess': 'Inquiry deleted successfully',
  'pages.enquiry.deleteError': 'Failed to delete inquiry',
  'pages.enquiry.empty': 'No inquiries found',

  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.close': 'Close',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.view': 'View',
  'common.loading': 'Loading…',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.active': 'Active',
  'common.inactive': 'Inactive',
  'common.free': 'Free',
  'common.unknownError': 'Unknown error',

  'bookingForm.titleCreate': 'Create Booking',
  'bookingForm.titleUpdate': 'Update Booking',
  'bookingForm.title': 'Title',
  'bookingForm.guestDetails': 'Guest Details',
  'bookingForm.slotAndStatus': 'Slot And Status',
  'bookingForm.calendarDate': 'Calendar Date',
  'bookingForm.slotsFilteredHint': 'Slots are filtered by selected date, month and year.',
  'bookingForm.slot': 'Slot',
  'bookingForm.contactPerson': 'Service person',
  'bookingForm.contactSelect': 'Service',
  'bookingForm.serviceSubcategories': 'Service (subcategories)',
  'bookingForm.noSubcategoriesForContact': 'No subcategories for this service; ensure it has a service category or subcategories in the list.',
  'bookingForm.subcategoriesHint': 'Choose one or more services. Selected ids are saved with the booking.',
  'bookingForm.subCategoriesRequired': 'Please select at least one service (subcategory).',
  'bookingForm.subCategoryResolveNeedsCategory':
    'This service needs a service category so selected services can be saved as IDs.',
  'bookingForm.subCategoryResolveFailed':
    'Could not match every selected service to a category ID. Check names against your subcategory list.',
  'bookingForm.status': 'Status',
  'bookingForm.guestFirstName': 'Guest First Name',
  'bookingForm.guestLastName': 'Guest Last Name',
  'bookingForm.guestEmail': 'Guest Email',
  'bookingForm.guestPhone': 'Guest Phone',
  'bookingForm.gender': 'Gender',
  'bookingForm.numberOfGuests': 'Number of Guests',
  'bookingForm.guestAge': 'Age',
  'bookingForm.guestAddress': 'Guest Address',
  'bookingForm.serviceAddress': 'Service Address',
  'bookingForm.notes': 'Notes',
  'bookingForm.slotLabel': 'Slot {{id}}',
  'bookingForm.contactLabel': 'Service {{id}}',
  'bookingForm.errorSelectService': 'Please select a service.',
  'bookingForm.selectServiceFirst': 'Select a service first.',
  'bookingForm.errorSave': 'Error creating/updating booking',

  'pages.bookings.dialog.title': 'Booking details',
  'pages.bookings.dialog.subtitle': 'Selected booking information',
  'pages.bookings.dialog.loading': 'Loading details',
  'pages.bookings.dialog.sectionService': 'Service information',
  'pages.bookings.dialog.sectionCustomer': 'User',
  'pages.bookings.dialog.labelTitle': 'Name',
  'pages.bookings.dialog.labelContactPerson': 'Service person',
  'pages.bookings.dialog.labelSubcategories': 'Services',
  'pages.bookings.dialog.labelName': 'Title',
  'pages.bookings.dialog.labelEmail': 'Email',
  'pages.bookings.dialog.labelPhone': 'Phone',
  'pages.bookings.dialog.labelGender': 'Gender',
  'pages.bookings.dialog.labelAddress': 'Address',

  'pages.contacts.stats.total': 'Total Contacts',
  'pages.contacts.stats.approved': 'Approved',
  'pages.contacts.stats.pending': 'Pending',
  'pages.contacts.stats.declined': 'Declined',
  'pages.contacts.stats.inactive': 'Inactive',
  'pages.contacts.clearFilters': 'Clear',
  'pages.contacts.loadingList': 'Loading contacts…',
  'pages.contacts.searchPlaceholder': 'Search by title, service person…',
  'pages.contacts.filter.approvalStatus': 'Approval Status',
  'pages.contacts.filter.allStatuses': 'All Statuses',
  'pages.contacts.status.approved': 'Approved',
  'pages.contacts.status.pending': 'Pending',
  'pages.contacts.status.declined': 'Declined',
  'pages.contacts.status.inactive': 'Inactive',
  'pages.contacts.tooltip.view': 'View',
  'pages.contacts.tooltip.edit': 'Edit',
  'pages.contacts.tooltip.delete': 'Delete',
  'pages.contacts.tab.general': 'General',
  'pages.contacts.tab.location': 'Location',
  'pages.contacts.tab.communication': 'Communication',
  'pages.contacts.tab.business': 'Settings',
  'pages.contacts.tab.info': 'Info',
  'pages.contacts.form.documentsRequired': 'Documents Required',
  'pages.contacts.form.rulesAndRegulations': 'Terms & Conditions',
  'pages.contacts.form.pricingInformation': 'Package Information',
  'pages.contacts.form.pricingInformationDescription': 'Create clear plan cards with pricing, billing period, and key benefits.',
  'pages.contacts.form.pricingEmptyTitle': 'No pricing plans added yet',
  'pages.contacts.form.pricingEmptyDescription': 'Add a plan to show customers your pricing and what is included.',
  'pages.contacts.form.pricingPlan': 'Pricing plan',
  'pages.contacts.form.untitledPricingPlan': 'Untitled plan',
  'pages.contacts.form.removePricingPlan': 'Remove pricing plan',
  'pages.contacts.form.addPricingPlan': 'Add pricing plan',
  'pages.contacts.form.pricingHeaderSection': 'Package Information',
  'pages.contacts.form.pricingHeaderTitle': 'Package Title',
  'pages.contacts.form.pricingHeaderTitlePlaceholder': 'e.g. Insurance Packages & What You Get',
  'pages.contacts.form.pricingHeaderDescription': 'Package Description',
  'pages.contacts.form.pricingHeaderDescriptionPlaceholder': 'e.g. Official visa-compliant packages for Germany',
  'pages.contacts.form.pricingTitle': 'Plan title',
  'pages.contacts.form.pricingBadge': 'Badge',
  'pages.contacts.form.noPricingBadge': 'No badge',
  'pages.contacts.form.badgeMostPopular': 'Most Popular',
  'pages.contacts.form.badgeFlexible': 'Flexible',
  'pages.contacts.form.pricingDescription': 'Description',
  'pages.contacts.form.pricingPrice': 'Price',
  'pages.contacts.form.pricingPeriod': 'Period',
  'pages.contacts.form.periodMonth': 'Monthly',
  'pages.contacts.form.periodYear': 'Yearly',
  'pages.contacts.form.periodWeek': 'Weekly',
  'pages.contacts.form.periodDay': 'Daily',
  'pages.contacts.form.periodOneTime': 'One-time',
  'pages.contacts.form.periodSession': 'Per session',
  'pages.contacts.form.periodConsultation': 'Per consultation',
  'pages.contacts.form.periodFree': 'Free',
  'pages.contacts.form.pricingHint': 'Price hint',
  'pages.contacts.form.pricingHighlights': 'Highlights',
  'pages.contacts.form.pricingHighlightPlaceholder': 'Add a plan highlight...',
  'pages.contacts.form.documentsRequiredPlaceholder': 'e.g. ID Card, Business Registration...',
  'pages.contacts.form.rulesAndRegulationsPlaceholder': 'e.g. Terms, cancellation policy...',
  'pages.contacts.form.addSession': 'Add session',
  'pages.contacts.form.closed': 'Closed',
  'pages.contacts.form.removeSession': 'Remove session',
  'pages.contacts.form.businessTitle': 'Business Title',
  'pages.contacts.form.contactPerson': 'Service person',
  'pages.contacts.form.description': 'Description',
  'pages.contacts.form.infoNote': 'Additional Info',
  'pages.contacts.form.infoPlaceholder': 'Internal or shared notes...',
  'pages.contacts.form.supportLanguages': 'Supported languages',
  'pages.contacts.form.supportLangPlaceholder': 'English, German',
  'pages.contacts.form.callToAction': 'Call to Action',
  'pages.contacts.form.callToActionPlaceholder': 'e.g. Click here, Register...',
  'pages.contacts.form.clientTypes': 'Client types',
  'pages.contacts.form.clientTypesPlaceholder': 'adult, child, senior',
  'pages.contacts.form.subcategories': 'Sub-categories',
  'pages.contacts.form.streetAddress': 'Street Address',
  'pages.contacts.form.houseNo': 'House No',
  'pages.contacts.form.zip': 'Zip Code',
  'pages.contacts.form.zipPlaceholder': '5 digits',
  'pages.contacts.form.city': 'City',
  'pages.contacts.form.district': 'District',
  'pages.contacts.form.selectCity': 'Select City',
  'pages.contacts.form.selectDistrict': 'Select District',
  'pages.contacts.form.longitude': 'Longitude',
  'pages.contacts.form.latPlaceholder': 'e.g. 52.535188',
  'pages.contacts.form.lonPlaceholder': 'e.g. 13.42535',
  'pages.contacts.form.latitude': 'Latitude',
  'pages.contacts.form.email': 'Email Address',
  'pages.contacts.form.phone': 'Phone Number',
  'pages.contacts.form.whatsapp': 'WhatsApp',
  'pages.contacts.form.website': 'Website URL',
  'pages.contacts.form.whatsappTemplate': 'WhatsApp message template',
  'pages.contacts.form.businessHours': 'Business Hours',
  'common.days.monday': 'Monday',
  'common.days.tuesday': 'Tuesday',
  'common.days.wednesday': 'Wednesday',
  'common.days.thursday': 'Thursday',
  'common.days.friday': 'Friday',
  'common.days.saturday': 'Saturday',
  'common.days.sunday': 'Sunday',
  'pages.contacts.form.hoursPlaceholder': 'Mon-Fri: 9:00 - 18:00...',
  'pages.contacts.form.bannerImages': 'Banner images',
  'pages.contacts.form.savedImages': 'Saved images:',
  'pages.contacts.form.logo': 'Logo picture',
  'pages.contacts.form.savedLogo': 'Saved logo:',
  'pages.contacts.form.addBanner': 'Add',
  'pages.contacts.form.addLogo': 'Add',
  'pages.contacts.form.changeLogo': 'Change',
  'pages.contacts.form.removeBanner': 'Remove banner',
  'pages.contacts.form.removeSavedBanner': 'Remove saved banner',
  'pages.contacts.form.removeLogo': 'Remove new logo',
  'pages.contacts.form.removeSavedLogo': 'Remove saved logo',
  'pages.contacts.form.isActive': 'isActive: {{value}}',
  'pages.contacts.form.bookingAppointments': 'Booking appointments',
  'pages.contacts.form.isBookingAppointmentExist': 'Booking appointment exist',
  'pages.contacts.form.isServiceBased': 'Service based',
  'pages.contacts.form.isChatEnabled': 'Chat Support',
  'pages.contacts.card.appointmentsOn': 'Bookings on',
  'pages.contacts.approval.reasonDecline': 'Reason for Declining',
  'pages.contacts.approval.reasonRequired': 'Reason is required',
  'pages.contacts.validation.titleRequired': 'Title is required.',
  'pages.contacts.validation.titleLength': 'Title cannot exceed 250 characters.',
  'pages.contacts.validation.contactPersonRequired': 'Service person is required.',
  'pages.contacts.validation.callToActionLength': 'Call to Action cannot exceed 30 characters.',
  'pages.contacts.dialog.close': 'Close',
  'pages.contacts.dialog.saveChanges': 'Save Changes',
  'pages.contacts.dialog.addContact': 'Add Service',
  'pages.contacts.dialog.editContact': 'Edit Service',
  'pages.contacts.dialog.saving': 'Saving…',
  'pages.contacts.dialog.adding': 'Adding…',
  'pages.contacts.dialog.switchToEdit': 'Switch to Edit',
  'pages.contacts.wizard.next': 'Next',
  'pages.contacts.wizard.previous': 'Previous',
  'pages.contacts.wizard.createContact': 'Create service',

  'pages.slots.addSlot': 'Add Slot',
  'pages.slots.stats.total': 'Total Slots',
  'pages.slots.stats.available': 'Available',
  'pages.slots.stats.booked': 'Booked',
  'pages.slots.stats.confirmed': 'Confirmed',
  'pages.slots.stats.today': 'Today\'s Slots',
  'pages.slots.filter.contact': 'Contact',
  'pages.slots.filter.template': 'Template',
  'pages.slots.filter.startDate': 'Start Date',
  'pages.slots.filter.endDate': 'End Date',
  'pages.slots.table.actions': 'Actions',
  'pages.slots.empty.title': 'No slots found',
  'pages.slots.empty.hint': 'Try adjusting filters or add a new slot.',
  'pages.slots.empty.subline': 'Generate some slots to get started.',
  'pages.slots.filter.allContacts': 'All Contacts',
  'pages.slots.filter.allTemplates': 'All Templates',
  'pages.slots.clearFilters': 'Clear',
  'pages.slots.generate.title': 'Generate Multiple Slots',
  'pages.slots.generate.now': 'Generate Now',
  'pages.slots.generate.subtitle': 'Quickly create availability for a range of dates',
  'pages.slots.rowsPerPage': 'Slots per page:',
  'pages.slots.form.templateOptional': 'Template (Optional)',
  'pages.slots.form.pastDates': 'Cannot select past dates',
  'pages.slots.form.endAfterStart': 'Must be on or after start date',
  'pages.slots.form.startTime': 'Start Time',
  'pages.slots.form.endTime': 'End Time',
  'pages.slots.form.durationMin': 'Duration (minutes)',
  'pages.slots.form.daysOfWeek': 'Days of week',
  'pages.slots.form.slotTitle': 'Title',
  'pages.slots.form.description': 'Description',
  'pages.slots.form.price': 'Price',
  'pages.slots.form.bookingType': 'Booking Type',
  'pages.slots.form.maxSlotsPerDay': 'Max Slots Per Day',
  'pages.slots.form.location': 'Location',
  'pages.slots.form.excludeHolidays': 'Exclude Holidays',
  'pages.slots.form.isRecurring': 'Is Recurring',
  'pages.slots.form.generate': 'Generate Slots',
  'pages.slots.form.templateOptional2': 'Template (optional)',
  'pages.slots.form.durationHelp': 'Auto-calculated from start and end time (must match for the server)',
  'pages.slots.form.maxCapacity': 'Max Capacity',
  'pages.slots.form.maxCapacityHelp': 'Number of people that can book this slot',
  'pages.slots.form.slotTitleLabel': 'Slot Title',
  'pages.slots.form.slotTitleHelp': 'e.g. General Consultation',
  'pages.slots.form.contactLoadsTemplateTitle': 'Choosing a contact loads the booking template for that contact into Title (and related fields) when available.',
  'pages.slots.btn.createSlot': 'Create Slot',
  'pages.slots.btn.saveChanges': 'Save Changes',
  'pages.slots.validation.maxCapacity': 'Max capacity cannot exceed 1000.',

  'pages.bookingTemplates.newTemplate': 'New Template',
  'pages.bookingTemplates.stats.total': 'Total Templates',
  'pages.bookingTemplates.stats.autoApproved': 'Auto-Approved',
  'pages.bookingTemplates.stats.totalBookings': 'Total Bookings',
  'pages.bookingTemplates.stats.avgDuration': 'Avg Duration (min)',
  'pages.bookingTemplates.loading': 'Loading templates…',
  'pages.bookingTemplates.empty.title': 'No templates yet',
  'pages.bookingTemplates.empty.hint': 'Create your first booking template to define availability, pricing, and settings for your services.',
  'pages.bookingTemplates.card.active': 'Active',
  'pages.bookingTemplates.card.inactive': 'Inactive',
  'pages.bookingTemplates.card.minutes': '{{n}} minutes',
  'pages.bookingTemplates.card.maxParticipants': 'Max {{n}} participant',
  'pages.bookingTemplates.card.maxParticipantsPlural': 'Max {{n}} participants',
  'pages.bookingTemplates.card.bookings': '{{n}} bookings',
  'pages.bookingTemplates.card.assignedUsers': 'Assigned Users:',
  'pages.bookingTemplates.card.noContact': 'No contact assigned',
  'pages.bookingTemplates.approval.auto': 'Auto-approved',
  'pages.bookingTemplates.approval.manual': 'Manual approval',
  'pages.bookingTemplates.approval.partial': 'Partial approval',
  'pages.bookingTemplates.deactivate': 'Deactivate',
  'pages.bookingTemplates.activate': 'Activate',
  'pages.bookingTemplates.dialog.view': 'View',
  'pages.bookingTemplates.dialog.edit': 'Edit',
  'pages.bookingTemplates.dialog.create': 'Create',
  'pages.bookingTemplates.dialog.title': '{{action}} booking template',
  'pages.bookingTemplates.switchToEdit': 'Switch to Edit',
  'pages.bookingTemplates.tab.general': 'General',
  'pages.bookingTemplates.tab.availability': 'Availability',
  'pages.bookingTemplates.tab.settings': 'Settings',
  'pages.bookingTemplates.tab.pricing': 'Pricing',
  'pages.bookingTemplates.field.templateName': 'Template Name',
  'pages.bookingTemplates.field.description': 'Description',
  'pages.bookingTemplates.field.duration': 'Duration (minutes)',
  'pages.bookingTemplates.field.maxParticipants': 'Max Participants',
  'pages.bookingTemplates.field.approvalType': 'Approval Type',
  'pages.bookingTemplates.menu.approvalAuto': 'Automatic',
  'pages.bookingTemplates.menu.approvalManual': 'Manual',
  'pages.bookingTemplates.menu.approvalPartial': 'Partial',
  'pages.bookingTemplates.assignUsersTitle': 'Assign User Template to Contact',
  'pages.bookingTemplates.assignUsersHint': 'Select which users can handle bookings for this template.',
  'pages.bookingTemplates.noContacts': 'No contacts available. Add contacts first.',
  'pages.bookingTemplates.field.active': 'Active',
  'pages.bookingTemplates.field.maxAdvanceDays': 'Max Advance Booking (days)',
  'pages.bookingTemplates.field.minAdvanceHours': 'Min Advance Booking (hours)',
  'pages.bookingTemplates.field.buffer': 'Buffer Time Between Slots (minutes)',
  'pages.bookingTemplates.workingHours': 'Slots Availability',
  'pages.bookingTemplates.field.enabled': 'Enabled',
  'pages.bookingTemplates.field.workingHoursStart': 'Start time',
  'pages.bookingTemplates.field.workingHoursEnd': 'End time',
  'pages.bookingTemplates.day.monday': 'Monday',
  'pages.bookingTemplates.day.tuesday': 'Tuesday',
  'pages.bookingTemplates.day.wednesday': 'Wednesday',
  'pages.bookingTemplates.day.thursday': 'Thursday',
  'pages.bookingTemplates.day.friday': 'Friday',
  'pages.bookingTemplates.day.saturday': 'Saturday',
  'pages.bookingTemplates.day.sunday': 'Sunday',
  'pages.bookingTemplates.settings.allowCancel': 'Allow Cancellation',
  'pages.bookingTemplates.settings.cancelDeadline': 'Cancellation Deadline (hours)',
  'pages.bookingTemplates.settings.requiresDeposit': 'Requires Deposit',
  'pages.bookingTemplates.settings.depositAmount': 'Deposit Amount',
  'pages.bookingTemplates.settings.autoReminders': 'Automatic Reminders',
  'pages.bookingTemplates.settings.reminderTitle': 'Reminder Times (hours before appointment)',
  'pages.bookingTemplates.settings.hoursChip': '{{n}} hours',
  'pages.bookingTemplates.settings.hoursLabel': 'Hours',
  'pages.bookingTemplates.settings.add': 'Add',
  'pages.bookingTemplates.pricing.none': 'No pricing',
  'pages.bookingTemplates.pricing.fixed': 'Fixed price',
  'pages.bookingTemplates.pricing.range': 'Price range',
  'pages.bookingTemplates.field.price': 'Price',
  'pages.bookingTemplates.field.minPrice': 'Minimum Price',
  'pages.bookingTemplates.field.maxPrice': 'Maximum Price',
  'pages.bookingTemplates.actions.close': 'Close',
  'pages.bookingTemplates.actions.saveChanges': 'Save Changes',
  'pages.bookingTemplates.actions.create': 'Create Template',
  'pages.bookingTemplates.wizard.next': 'Next',
  'pages.bookingTemplates.wizard.previous': 'Previous',
  'pages.bookingTemplates.wizard.createBooking': 'Create booking',
  'pages.bookingTemplates.validation.required': 'Required',
  'pages.bookingTemplates.validation.wholeNumber': 'Must be a whole number',
  'pages.bookingTemplates.validation.minOne': 'Must be at least 1',
  'pages.bookingTemplates.validation.durationRange': 'Duration must be between 15 and 1440 minutes',
  'pages.bookingTemplates.validation.maxParticipantsRange': 'Max participants cannot exceed 5000',
  'pages.bookingTemplates.validation.nonNegative': 'Must be 0 or greater',
  'pages.bookingTemplates.validation.invalidTime': 'Enter a valid start and end time',
  'pages.bookingTemplates.validation.endAfterStart': 'End time must be after start time',
  'pages.bookingTemplates.validation.minAdvanceVsMax': 'Min advance (hours) cannot exceed max advance (days × 24)',
  'pages.bookingTemplates.validation.maxAdvanceDaysRange': 'Must be between 1 and 60 days',
  'pages.bookingTemplates.validation.minAdvanceHoursRange': 'Must be between 1 and 24 hours',
  'pages.bookingTemplates.validation.bufferTimeRange': 'Must be between 0 and 60 minutes',
  'pages.bookingTemplates.validation.depositPositive': 'Deposit amount must be greater than 0',
  'pages.bookingTemplates.validation.atLeastOneReminder': 'Add at least one reminder time',
  'pages.bookingTemplates.validation.priceRangeOrder': 'Maximum price must be greater than or equal to minimum',
  'pages.bookingTemplates.error.loadFailed': 'Failed to load templates',
  'pages.bookingTemplates.error.fetch': 'An error occurred while fetching templates',
  'pages.bookingTemplates.toast.selectContact': 'Please select a contact for this template',
  'pages.bookingTemplates.toast.contactIdUpdate': 'Contact ID is required for update',
  'pages.bookingTemplates.toast.updated': 'Template updated successfully',
  'pages.bookingTemplates.toast.created': 'Template created successfully',
  'pages.bookingTemplates.toast.saveFailed': 'Failed to save template',
  'pages.bookingTemplates.confirm.deleteTitle': 'Delete Booking Template',
  'pages.bookingTemplates.confirm.delete': 'Are you sure you want to delete this booking template? This action cannot be undone.',
  'pages.bookingTemplates.btn.cancel': 'Cancel',
  'pages.bookingTemplates.btn.delete': 'Delete',
  'pages.contacts.confirm.deleteTitle': 'Delete Contact',
  'pages.contacts.confirm.delete': 'Are you sure you want to delete this contact? This action cannot be undone.',
  'pages.contacts.btn.cancel': 'Cancel',
  'pages.contacts.btn.delete': 'Delete',
  'pages.bookingTemplates.toast.deleted': 'Template deleted successfully',
  'pages.bookingTemplates.toast.deleteFailed': 'Failed to delete template',
  'pages.bookingTemplates.toast.contactIdToggle': 'Contact ID is required for toggle status',
  'pages.bookingTemplates.toast.toggleActivated': 'Template activated successfully',
  'pages.bookingTemplates.toast.toggleDeactivated': 'Template deactivated successfully',
  'pages.bookingTemplates.toast.toggleFailed': 'Failed to toggle status',
  'pages.bookingTemplates.toast.contactIdEdit': 'Contact ID is required for edit',
  'pages.bookingTemplates.toast.loadEditFailed': 'Failed to load template for edit',
  'pages.bookingTemplates.toast.contactIdView': 'Contact ID is required to view template',
  'pages.bookingTemplates.toast.loadViewFailed': 'Failed to load template',
  'common.validation.passwordTooShort': 'Password must be at least 8 characters',
  'common.validation.passwordTooLong': 'Password must be at most 12 characters',
  'common.validation.passwordWeak': 'Password must include uppercase, lowercase, numbers, and special characters (@$!%*?&#)',
  'pages.bookings.dialog.notifyCustomerHint': 'Customer will receive a transfer confirmation',
  'common.date': 'Date',
  'pages.promotions.title': 'Promotion Management',
  'pages.promotions.subtitle': 'Manage and organize your promotional campaigns and discount listings',
  'pages.promotions.searchPlaceholder': 'Search by title, service person...',
  'pages.promotions.addBtn': '+ Add Promotion',
  'pages.promotions.editTitle': 'Edit Promotion',
  'pages.promotions.addTitle': 'Add Promotion',
  'pages.promotions.deleteTitle': 'Delete Promotion',
  'pages.promotions.confirmDelete': 'Are you sure you want to delete this promotion? This action cannot be undone.',
  'pages.promotions.filter.statusAll': 'Approval Status',
  'pages.promotions.filter.statusActive': 'Active',
  'pages.promotions.filter.statusInactive': 'Inactive',
  'pages.promotions.filter.clear': 'Clear',
  'pages.promotions.empty.title': 'No Promotions Found',
  'pages.promotions.empty.hint': 'Click "+ Add Promotion" above to add your first promotional offer.',
  'pages.promotions.card.city': 'City',
  'pages.promotions.card.coupon': 'Coupon',
  'pages.promotions.card.active': 'Active',
  'pages.promotions.card.inactive': 'Inactive',
  'pages.promotions.card.deactivate': 'Deactivate',
  'pages.promotions.card.activate': 'Activate',
  'pages.promotions.card.edit': 'Edit Promotion',
  'pages.promotions.card.delete': 'Delete Promotion',
  'pages.promotions.card.defaultBanner': 'GetSettled Promotion',
  'pages.promotions.card.defaultType': 'Promotion',
  'pages.promotions.card.copyCoupon': 'Copy Coupon Code',
  'pages.promotions.card.mobilePreview': 'Mobile Preview',
  'pages.promotions.status.approved': 'APPROVED',
  'pages.promotions.status.pending': 'PENDING',
  'pages.promotions.status.rejected': 'REJECTED',
  'pages.promotions.validation.titleRequired': 'Promotion Title is required',
  'pages.promotions.validation.titleMinLength': 'Title must be at least 3 characters',
  'pages.promotions.validation.descriptionRequired': 'Description is required',
  'pages.promotions.validation.cityRequired': 'City is required',
  'pages.promotions.validation.typeRequired': 'Promotion Type is required',
  'pages.promotions.validation.dateRequired': 'Promotion Date is required',
  'pages.promotions.validation.timeRequired': 'Promotion Time is required',
  'pages.promotions.validation.webUrlInvalid': 'Please enter a valid URL (e.g. https://example.com/offer)',
  'pages.promotions.validation.sharingUrlInvalid': 'Please enter a valid URL (e.g. https://example.com/share)',
  'pages.promotions.toast.couponCopied': 'Coupon code "{{code}}" copied to clipboard!',
  'pages.promotions.toast.fillRequired': 'Please fill in all required fields',
  'pages.promotions.toast.updateSuccess': 'Promotion updated successfully',
  'pages.promotions.toast.createSuccess': 'Promotion created successfully',
  'pages.promotions.toast.activated': 'Promotion activated',
  'pages.promotions.toast.deactivated': 'Promotion deactivated',
  'pages.promotions.toast.deleteSuccess': 'Promotion deleted successfully',
  'pages.promotions.toast.saveFailed': 'Failed to save promotion',
  'pages.promotions.toast.statusFailed': 'Status update failed',
  'pages.promotions.toast.deleteFailed': 'Failed to delete promotion',
  'pages.promotions.fields.title': 'Promotion Title',
  'pages.promotions.fields.description': 'Description',
  'pages.promotions.fields.details': 'Promotion Details (optional)',
  'pages.promotions.fields.detailsLabel': 'Details',
  'pages.promotions.fields.city': 'City',
  'pages.promotions.fields.type': 'Promotion Type',
  'pages.promotions.fields.bannerImage': 'Pictures / Banner Images',
  'pages.promotions.fields.uploadBtn': '+ Upload',
  'pages.promotions.fields.discountText': 'Discount Text (optional)',
  'pages.promotions.fields.discountCoupon': 'Discount Coupon (optional)',
  'pages.promotions.fields.couponTitle': 'Coupon Title (optional)',
  'pages.promotions.fields.promotionDate': 'Promotion Date (YYYY-MM-DD)',
  'pages.promotions.fields.promotionTime': 'Promotion Time (HH:mm)',
  'pages.promotions.fields.webUrl': 'Web URL (optional)',
  'pages.promotions.fields.sharingUrl': 'Sharing URL (optional)',
  'pages.promotions.fields.ownerName': 'Owner Name (optional)',
  'pages.promotions.fields.terms': 'Terms And Conditions (optional)',
  'pages.promotions.fields.targetedAudience': 'Targeted Audience (optional)',
  'pages.promotions.fields.whatYouGet': 'What You Get',
  'pages.promotions.fields.addItem': 'Add Item',
  'pages.promotions.fields.add': 'Add',
  'pages.promotions.fields.noItems': 'No items added yet. Click "Add Item" to add.',
  'pages.promotions.fields.active': 'Active',
  'pages.promotions.cta.title': 'Call To Action',
  'pages.promotions.cta.textEn': 'Call To Action (English)',
  'pages.promotions.cta.textDe': 'Call To Action (Deutsch)',
  'pages.promotions.cta.type': 'Call To Action Type',
  'pages.promotions.cta.url': 'Call To Action Link / URL',
  'pages.promotions.placeholders.discountText': 'e.g. 20% OFF or Save $50',
  'pages.promotions.placeholders.discountCoupon': 'e.g. SUMMER20',
  'pages.promotions.placeholders.couponTitle': 'e.g. Summer coupon',
  'pages.promotions.placeholders.webUrl': 'https://example.com/offer',
  'pages.promotions.placeholders.sharingUrl': 'https://example.com/share',
  'pages.promotions.placeholders.targetedAudience': 'e.g. All new customers in Berlin',
  'pages.promotions.placeholders.cta': 'e.g. Book Now, Claim Offer',
  'pages.promotions.placeholders.ctaEn': 'e.g. Book Now, Claim Offer',
  'pages.promotions.placeholders.ctaDe': 'e.g. Jetzt buchen, Angebot sichern',
  'pages.promotions.placeholders.whatYouGetItem': 'Enter an item (e.g. Free Consultation, 15% discount code)',
  'pages.promotions.type.discount': 'Discount',
  'pages.promotions.type.specialoffer': 'Special Offer',
  'pages.promotions.type.event': 'Event',
  'pages.promotions.type.banner': 'Banner',
  'pages.promotions.type.voucher': 'Voucher',
  'pages.promotions.type.general': 'General',
  'pages.promotions.btn.cancel': 'Cancel',
  'pages.promotions.btn.save': 'Save Changes',
  'pages.promotions.btn.create': 'Create Promotion',
  'pages.promotions.btn.close': 'Close',
  'pages.promotions.btn.delete': 'Delete',

  // Custom Push Notifications Page
  'pages.customPush.title': 'Custom Push Notifications',
  'pages.customPush.subtitle': 'Create, manage, edit, and track custom push notifications for promotion.',
  'pages.customPush.addNotification': 'Add Notification',
  'pages.customPush.searchPlaceholder': 'Search notifications by title or message...',
  'pages.customPush.status': 'Status',
  'pages.customPush.allStatuses': 'All Statuses',
  'pages.customPush.allCategories': 'All Categories',
  'pages.customPush.allServices': 'All Services',
  'pages.customPush.filterService': 'Service',
  'pages.customPush.statusApproved': 'Approved',
  'pages.customPush.statusPending': 'Pending',
  'pages.customPush.statusRejected': 'Rejected',
  'pages.customPush.clearFilters': 'Clear Filters',
  'pages.customPush.tableHeaderDetails': 'Notification Details',
  'pages.customPush.tableHeaderCategory': 'Category',
  'pages.customPush.tableHeaderTargetTitle': 'Service Title',
  'pages.customPush.tableHeaderNote': 'Note',
  'pages.customPush.tableHeaderDate': 'Date Created',
  'pages.customPush.tableHeaderStatus': 'Status',
  'pages.customPush.tableHeaderActions': 'Actions',
  'pages.customPush.loading': 'Loading notifications...',
  'pages.customPush.noNotificationsTitle': 'No Notifications Found',
  'pages.customPush.noNotificationsSubtitle': 'Try adjusting your search query or status filter to find notifications.',
  'pages.customPush.tooltipView': 'View Notification Details',
  'pages.customPush.tooltipEdit': 'Edit Notification',
  'pages.customPush.tooltipEditDisabled': 'Approved notifications cannot be edited',
  'pages.customPush.tooltipDelete': 'Delete Notification',
  'pages.customPush.tooltipDeleteDisabled': 'Approved notifications cannot be deleted',
  'pages.customPush.dialogAddTitle': 'Add Notification',
  'pages.customPush.dialogEditTitle': 'Edit Notification',
  'pages.customPush.dialogAddSubtitle': 'Compose and send push notification to users',
  'pages.customPush.dialogEditSubtitle': 'Modify details before broadcasting',
  'pages.customPush.fieldCategory': 'Notification Category',
  'pages.customPush.categoryContact': 'Service',
  'pages.customPush.categoryPromotion': 'Promotion',
  'pages.customPush.categoryCustom': 'Custom (No Link)',
  'pages.customPush.fieldContact': 'Select Service',
  'pages.customPush.fieldContactPlaceholder': 'Select a service...',
  'pages.customPush.fieldPromotion': 'Select Promotion',
  'pages.customPush.fieldPromotionPlaceholder': 'Select a promotion...',
  'pages.customPush.fieldEvent': 'Select Event',
  'pages.customPush.fieldEventPlaceholder': 'Select an event...',
  'pages.customPush.fieldTitle': 'Notification Title',
  'pages.customPush.fieldTitlePlaceholder': 'e.g. 🎉 Special Weekend Promotion 20% Off',
  'pages.customPush.fieldMessage': 'Notification Message',
  'pages.customPush.fieldMessagePlaceholder': 'Enter notification message description...',
  'pages.customPush.btnCancel': 'Cancel',
  'pages.customPush.btnSaving': 'Saving...',
  'pages.customPush.btnUpdate': 'Update Notification',
  'pages.customPush.btnSend': 'Send Notification',
  'pages.customPush.deleteConfirmTitle': 'Confirm Delete',
  'pages.customPush.deleteConfirmMessage': 'Are you sure you want to delete the notification "{{title}}"? This action cannot be undone.',
  'pages.customPush.btnDelete': 'Delete',
  'pages.customPush.viewDetailsTitle': 'Notification Details',
  'pages.customPush.viewDetailsLoading': 'Fetching notification details...',
  'pages.customPush.viewFieldTitle': 'Title',
  'pages.customPush.viewFieldCategory': 'Category',
  'pages.customPush.viewFieldTargetTitle': 'Service Title',
  'pages.customPush.viewFieldContact': 'Service',
  'pages.customPush.viewFieldPromotion': 'Promotion',
  'pages.customPush.viewFieldEvent': 'Event',
  'pages.customPush.viewFieldMessage': 'Message Content',
  'pages.customPush.viewFieldAdminNote': 'Admin Note',
  'pages.customPush.viewFieldDateCreated': 'Date Created',
  'pages.customPush.viewFieldProviderName': 'Provider Name',
  'pages.customPush.viewFieldProviderEmail': 'Provider Email',
  'pages.customPush.btnClose': 'Close',
  'pages.customPush.toastSelectContact': 'Please select a service.',
  'pages.customPush.toastSelectPromotion': 'Please select a promotion.',
  'pages.customPush.toastSelectEvent': 'Please select an event.',
  'pages.customPush.toastEnterTitle': 'Please enter a notification title.',
  'pages.customPush.toastEnterMessage': 'Please enter notification message text.',
  'pages.customPush.toastApprovedCannotEdit': 'Approved notifications cannot be edited.',
  'pages.customPush.toastApprovedCannotDelete': 'Approved notifications cannot be deleted.',
  'pages.customPush.toastUpdatedSuccess': 'Notification updated successfully!',
  'pages.customPush.toastCreatedSuccess': 'Notification created and sent successfully!',
  'pages.customPush.toastSaveFailed': 'Failed to save notification. Please try again.',
  'pages.customPush.toastDeletedSuccess': 'Notification deleted successfully.',
  'pages.customPush.toastDeleteFailed': 'Failed to delete notification.',
  'pages.customPush.tabGeneric': 'Generic Notification',
  'pages.customPush.tabCustom': 'Custom Notification',
  'pages.customPush.sendCustomNotification': 'Send Custom Notification',
  'pages.customPush.dialogCustomTitle': 'Send Custom Push Notification',
  'pages.customPush.dialogCustomSubtitle': 'Broadcast targeted push notification based on service and interaction lookback',
  'pages.customPush.fieldModule': 'Module',
  'pages.customPush.fieldLookbackDays': 'Lookback Period (Days)',
  'pages.customPush.fieldLookbackDaysPlaceholder': 'Enter lookback days (e.g. 30)',
  'pages.customPush.fieldLookbackDaysHelp': 'Targets active customers who interacted with this service within the last X days.',
  'pages.customPush.tableHeaderModule': 'Module',
  'pages.customPush.tableHeaderEntity': 'Target Service',
  'pages.customPush.tableHeaderLookback': 'Lookback',
  'pages.customPush.tableHeaderRecipients': 'Recipients',
  'pages.customPush.viewFieldModule': 'Module',
  'pages.customPush.viewFieldLookbackDays': 'Lookback Period',
  'pages.customPush.viewFieldRecipients': 'Total Eligible Recipients',
  'pages.customPush.viewFieldSuccessCount': 'Successful Deliveries',
  'pages.customPush.viewFieldFailureCount': 'Failed Deliveries',
  'pages.customPush.toastCustomSentSuccess': 'Custom push notification sent successfully!',
  'pages.customPush.toastCustomSendFailed': 'Failed to send custom notification.',
  'pages.customPush.historyEmptyTitle': 'No Custom Notifications Sent Yet',
  'pages.customPush.historyEmptySubtitle': 'Click "Send Custom Notification" to broadcast targeted notifications to customers.',
  'pages.customPush.loadingHistory': 'Loading notification history...',
  'pages.customPush.statusSent': 'Sent',
};
